/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_4e927e22"]'><cube-tab-bar :value="selectedLabelInline" mpxModelEvent="input" :tabs="(tabs)" show-slider inline custom-content @_click="clickHandler" @mpxModel='(e)=>__invoke(e, [["__model","selectedLabelInline", "__mpx_event__", ["value"], undefined]])' @change='(e)=>__invoke(e, [["changeHandler"]])'><cube-tab v-for="(item, index) in (tabs)" :key="item.label" :icon="(item.icon)" :label="(item.label)" :value="(item.value)" :class='["cube-tab"]'></cube-tab></cube-tab-bar></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_4e927e22"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_4e927e22"}
  /** script content **/
  require("./tab-bar-inline.mpx.js?isComponent&outputPath=components%2Ftab-bar-inline4e927e22%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./tab-bar-inline.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ftab-bar-inline4e927e22%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_4e927e22"],
    ctorType: "component",
    outputPath: "components/tab-bar-inline4e927e22/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-tab-bar':getComponent(require("../../../packages/mpx-cube-ui/src/components/tab-bar/index.mpx?isComponent&outputPath=components%2Findexff7d3170%2Findex")),'cube-tab':getComponent(require("../../../packages/mpx-cube-ui/src/components/tab-bar/tab.mpx?isComponent&outputPath=components%2Ftab66c6e44b%2Findex")),'cube-icon':getComponent(require("../../../packages/mpx-cube-ui/src/components/icon/index.mpx?isComponent&outputPath=components%2Findex1d853680%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>